import { Shield, Lock, CreditCard, Building2, CheckCircle, Globe, Fingerprint } from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-border/50 mt-auto">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Logo size="sm" linkTo={null} dataTestId="footer-logo" />
            <p className="text-sm text-muted-foreground leading-relaxed mb-4 mt-4">
              Ghana&rsquo;s automotive marketplace. Verified sellers, escrow payments, AI fraud protection.
            </p>
            <div className="flex flex-wrap gap-2" data-testid="footer-trust-badges">
              <span className="inline-flex items-center gap-1 text-[10px] bg-trust-green/10 text-trust-green px-2 py-1 rounded-full">
                <CheckCircle className="w-3 h-3" /> AI Verified
              </span>
              <span className="inline-flex items-center gap-1 text-[10px] bg-blue-400/10 text-blue-400 px-2 py-1 rounded-full">
                <Lock className="w-3 h-3" /> Secure
              </span>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3">Marketplace</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/browse" className="hover:text-foreground transition-colors">Browse Cars</Link></li>
              <li><Link to="/browse?type=part" className="hover:text-foreground transition-colors">Browse Parts</Link></li>
              <li><Link to="/sell" className="hover:text-foreground transition-colors">Sell</Link></li>
              <li><Link to="/kyc" className="hover:text-foreground transition-colors">Get Verified</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3">Company</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/about" className="hover:text-foreground transition-colors">About</Link></li>
              <li><Link to="/trust" className="hover:text-foreground transition-colors">Trust &amp; Safety</Link></li>
              <li><Link to="/index" className="hover:text-foreground transition-colors">AutoTrust Index</Link></li>
              <li><Link to="/press" className="hover:text-foreground transition-colors">Press</Link></li>
              <li><Link to="/careers" className="hover:text-foreground transition-colors">Careers</Link></li>
              <li><Link to="/blog" className="hover:text-foreground transition-colors">Blog</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3">Support</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/help" className="hover:text-foreground transition-colors">Help Center</Link></li>
              <li><Link to="/help#safety" className="hover:text-foreground transition-colors">Safety Tips</Link></li>
              <li><Link to="/help#escrow" className="hover:text-foreground transition-colors">Escrow Guide</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/legal" className="hover:text-foreground transition-colors">Terms of Service</Link></li>
              <li><Link to="/legal?tab=privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/legal?tab=escrow" className="hover:text-foreground transition-colors">Escrow Terms</Link></li>
            </ul>
          </div>
        </div>

        {/* Partner & Certification Badges */}
        <div className="mt-8 pt-6 border-t border-border/50">
          <p className="text-center text-[10px] text-muted-foreground uppercase tracking-wider mb-4">Trusted Partners & Certifications</p>
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10">
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <div className="w-8 h-8 rounded-full bg-cyan-400/10 flex items-center justify-center">
                <CreditCard className="w-4 h-4 text-cyan-400" />
              </div>
              <div>
                <p className="font-medium text-foreground">Paystack</p>
                <p className="text-[10px]">Payment Partner</p>
              </div>
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <div className="w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center">
                <Building2 className="w-4 h-4 text-gold" />
              </div>
              <div>
                <p className="font-medium text-foreground">Ghana Registered</p>
                <p className="text-[10px]">Licensed Business</p>
              </div>
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <div className="w-8 h-8 rounded-full bg-trust-green/10 flex items-center justify-center">
                <Globe className="w-4 h-4 text-trust-green" />
              </div>
              <div>
                <p className="font-medium text-foreground">SSL Encrypted</p>
                <p className="text-[10px]">256-bit Security</p>
              </div>
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <div className="w-8 h-8 rounded-full bg-blue-400/10 flex items-center justify-center">
                <Fingerprint className="w-4 h-4 text-blue-400" />
              </div>
              <div>
                <p className="font-medium text-foreground">Data Protected</p>
                <p className="text-[10px]">Ghana DPA 2012</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-border/50 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>© 2026 AutoTrust Ghana. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/legal" className="hover:text-foreground transition-colors">Terms</Link>
            <Link to="/legal?tab=privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/help" className="hover:text-foreground transition-colors">Help</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
